import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const ConseilFormation = () => {
  const sectorData = {
    title: "Conseil & Formation",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les acteurs du conseil en stratégie, de la formation professionnelle ou du coaching B2B doivent sans cesse renouveler leur offre face à des décideurs exigeants. Dans ce secteur où la concurrence est forte, se différencier via des contenus experts, prouver la valeur de ses formations certifiées ou de ses audits organisationnels et démontrer un ROI pédagogique est essentiel pour générer des leads qualifiés.",
    name: "Conseil & Formation",
    titleContext: "du conseil et de la formation",
    responseContext: "du secteur Conseil & Formation",
    expertContext: "du secteur Conseil & Formation"
  };

  return <SectorPage sector={sectorData} />;
};

export default ConseilFormation; 